<template>
  <button
    :class="buttonIconRounded.class"
    :data-tooltip-text="buttonIconRounded.tooltip"
    :type="buttonIconRounded.type"
    @click="click()"
  >
    <i :class="buttonIconRounded.icon"></i>
  </button>
</template>

<script>
export default {
  name: 'AtomButtonIconRounded',

  props: {
    buttonIconRounded: Object,
    element: [Number, String, Object]
  },

  methods: {
    click () {
      if (this.buttonIconRounded.component) {
        this.$emit(this.buttonIconRounded.method, this.buttonIconRounded.component, this.element)
      } else {
        this.$emit(this.buttonIconRounded.method, this.element)
      }
    }
  }
}
</script>
